export class AddUserModel {
  fullArabicName!: string
  fullEnglishName!: string
  identityNumber!: string
  cityId!: number
  countryId!: number
  phoneNumber!: string
  phoneExtension!: string
  dateOfBirth!: any
  email!: string
  genderEnum!: number
  userId?: any
  removeUserImage?: boolean
}
